import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checkmark",
  "use": "icon-checkmark-usage",
  "viewBox": "0 0 22 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 16\" id=\"icon-checkmark\"><path d=\"m5 15.44-5-5 1.06-1.061 5 5a.25.25 0 0 0 .354 0l14.38-14.38 1.06 1.06L7.476 15.44a1.75 1.75 0 0 1-2.475 0Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol